import {
    Component,
    ElementRef,
    HostListener,
    OnInit,
    OnDestroy,
    ViewChild,
    Input,
    Output,
    EventEmitter
} from '@angular/core';

@Component({
    selector: 'app-fireworks',
    templateUrl: './fireworks-ad.component.html',
    standalone: true,
    styles: `canvas {
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
    }`
})
export class FireworksAdComponent implements OnInit, OnDestroy {
    @ViewChild('fireworksCanvas', { static: true }) canvasRef!: ElementRef<HTMLCanvasElement>;
    @Input() source: string = 'https://www.adaptivewfs.com/wp-content/uploads/2020/07/logo-placeholder-image.png';
    @Output() onEnd: EventEmitter<any> = new EventEmitter();
    private ctx!: CanvasRenderingContext2D;
    private img: any;
    private fireworks: Firework[] = [];
    private animationFrameId: number | null = null;

    constructor() {
        this.img = new Image();
    }

    ngOnInit(): void {
        const canvas = this.canvasRef.nativeElement;
        this.ctx = canvas.getContext('2d')!;
        this.img.src = this.source; // Replace with your image path
        this.resizeCanvas();

        // Create fireworks at intervals
        //for (let i = 0; i < 5; i++) {
            //setTimeout(() =>
                this.createFirework()
                //, 1000 * i);
        //}

        setTimeout(() => {
            this.onEnd.emit();
        }, 9000);
        this.animate();
    }

    @HostListener('window:resize')
    resizeCanvas(): void {
        const canvas = this.canvasRef.nativeElement;
        canvas.width = window.innerWidth;
        canvas.height = window.innerHeight;
    }

    createFirework(): void {
        const x = Math.random() * this.canvasRef.nativeElement.width;
        const y = this.canvasRef.nativeElement.height;
        this.fireworks.push(new Firework(x, y, this.ctx, this.img));
    }

    animate(): void {
        this.ctx.clearRect(0, 0, this.canvasRef.nativeElement.width, this.canvasRef.nativeElement.height);

        this.fireworks.forEach((firework, index) => {
            firework.update();
            firework.draw();
            if (firework.particles.every(p => p.life <= 0)) {
                this.fireworks.splice(index, 1);
            }
        });

        this.animationFrameId = requestAnimationFrame(() => this.animate());
    }

    ngOnDestroy(): void {
        if (this.animationFrameId) {
            cancelAnimationFrame(this.animationFrameId);
        }
    }
}

class Firework {
    particles: Particle[] = [];

    constructor(
        private x: number,
        private y: number,
        private ctx: CanvasRenderingContext2D,
        private img: HTMLImageElement
    ) {
        for (let i = 0; i < 100; i++) {
            this.particles.push(new Particle(this.x, this.y, this.ctx, this.img));
        }
    }

    update(): void {
        this.particles.forEach(p => p.update());
    }

    draw(): void {
        this.particles.forEach(p => p.draw());
    }
}

class Particle {
    x: number;
    y: number;
    width: number;
    speedX: number;
    speedY: number;
    life: number = 1000;

    constructor(
        x: number,
        y: number,
        private ctx: CanvasRenderingContext2D,
        private img: HTMLImageElement
    ) {
        this.x = x;
        this.y = window.innerHeight - 100;
        this.width = Math.random() * 100 + 5; // Adjust width for better visibility
        this.speedX = (Math.random() - 0.5) * 5;
        this.speedY = (Math.random() - 0.5) * 5;
    }

    update(): void {
        this.x += this.speedX;
        this.y += this.speedY;
        this.life--;
    }

    draw(): void {
        if (this.img.complete) {
            let aspectRatio = this.img.height / this.img.width;
            let height = this.width * aspectRatio;
            this.ctx.drawImage(this.img, this.x, this.y, this.width, height);
        }
    }
}
